// extracted by mini-css-extract-plugin
module.exports = {"container":"orders-list_container__2tiCV","orderLink":"orders-list_orderLink__-EkTq"};